<template>
  <v-form
    ref="contactForm"
    v-model="valid"
    lazy-validation
  >
    <v-row class="spacer" align="center">
      <v-col sm="5">
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <v-text-field
                  :label="$t('locations.name')"
                  v-model="updatedContact.name"
                  :rules="[v => !!v || $t('general.required_field')]"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  :label="$t('locations.surname')"
                  v-model="updatedContact.surname"
                  :rules="[v => !!v || $t('general.required_field')]"
                ></v-text-field>
              </v-col>
            </v-row>

          </v-col>
          <v-col>
            <v-text-field
              :label="$t('locations.position')"
              v-model="updatedContact.position"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col sm="5">
        <v-row>
          <v-col>
            <v-text-field
              :label="$t('locations.email')"
              v-model="updatedContact.email"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('locations.phone_number')"
              v-model="updatedContact.phone_number"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col sm="2" class="text-right">
        <v-btn
          color=kazan
          outlined
          small
          @click="saveContact"
        >
          {{$t('buttons.save')}}
        </v-btn>
        <v-btn
          outlined
          small
          @click="$emit('editDone')"
        >
          {{$t('buttons.cancel')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ContactForm',
  props: {
    contact: Object
  },
  data () {
    return {
      valid: true,
      updatedContact: this.contact,
      emailRules: [
        v => !!this.emailOrPhoneFilled || this.$i18n.t('general.required_phone_or_email'),
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('general.email_not_valid')
      ],
      phoneRules: [
        v => !!this.emailOrPhoneFilled || this.$i18n.t('general.required_phone_or_email')
      ]
    }
  },
  computed: {
    ...mapState(['contacts']),
    emailOrPhoneFilled () {
      return (!!this.updatedContact.email || !!this.updatedContact.phone_number)
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    saveContact () {
      if (this.$refs['contactForm'].validate()) {
        // TODO: call API for create/update contact
        let snackMsg = ''
        let snackColor = ''
        if (this.contact.id === undefined) {
          // this.createContact(contact)
          if (this.contacts.error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.contact_created')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
        } else {
          // this.updateContact(contact)
          if (this.contacts.error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.contact_updated')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
        }
        this.$emit('editDone')
      }
    }
  }
}
</script>
